import background from '@assets/background.svg';
import classNames from 'classnames';
import { ReactNode } from 'react';

interface AuthPepperProps {
	children: ReactNode;
	className?: string;
	withImage?: boolean;
}

export function AuthPepper({ children, className, withImage }: AuthPepperProps) {
	return (
		<div
			className={classNames(
				'flex flex-col min-h-screen justify-center items-center relative',
				className
			)}
			style={
				withImage
					? {
							backgroundImage: `url(${background})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
						}
					: {}
			}
		>
			{children}
		</div>
	);
}
